import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<g fill="none" fill-rule="evenodd"> <circle fill="currentColor" cx="12" cy="12" r="12" /> <path d="M17.143 12.857h-4.286v4.286a.857.857 0 1 1-1.714 0v-4.286H6.857a.857.857 0 0 1 0-1.714h4.286V6.857a.857.857 0 0 1 1.714 0v4.286h4.286a.857.857 0 1 1 0 1.714z" fill="#fff" fill-rule="nonzero" /> </g>' }
  })
);